export const fontWeightConfig = {
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

export const radiusConfig = {
  button: "32px",
  input: "8px",
  dropdown: "8px",
  card: "10px",
  tooltip: "8px",
  circle: "50%",
  square: '2px',
  searchButton: "4px",
};
